
import STKAnimated from "../animated";
import css from "./styles.module.scss"; 

type Props = {
    children: JSX.Element | JSX.Element[]
}

const STKConfirmationBox = ( props: Props ) => {

    return(
        <div className={css.confirmationBox}>
            {props.children}
        </div> 
    );

}

export default STKConfirmationBox;